import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

interface SessionToken {
  user_id?: string;
  tenant_id?: string;
  role_id?: string;
  api_key?: string;
}

export const useTokenSession = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(search).get("token");

  useEffect(() => {
    if (!token) {
      return;
    }
    try {
      const decodedToken = jwtDecode<SessionToken>(token);
      localStorage.setItem("user_id", decodedToken.user_id || "");
      localStorage.setItem("tenant_id", decodedToken.tenant_id || "");
      localStorage.setItem("role_id", decodedToken.role_id || "");
      localStorage.setItem("api_key", decodedToken.api_key || "");
      const cleanUrl = `${globalThis.location.origin}${globalThis.location.pathname}`;
      globalThis.history.replaceState({}, document.title, cleanUrl);
    } catch {}
  }, [token]);

  useEffect(() => {
    if (!localStorage.getItem("api_key")) {
      navigate("/log-in");
    }
  }, [navigate]);
};
